module.exports = __webpack_public_path__ + "img/tisu_logo.c560ef32.png";